import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
const includes = ['6 Tomos clínicos — 300 páginas', '4 Bonos profesionales — 160 páginas', '460+ páginas de contenido basado en evidencia', 'Acceso inmediato en PDF', 'Descargable desde cualquier país de LATAM', 'Pago único sin suscripción', 'Conversión automática a tu moneda local', 'Garantía de 7 días'];
export function ClosingBlock() {
  return <section id="cierre" className="w-full scroll-mt-20 bg-slate px-5 py-14 sm:py-24" data-id="element-41" data-mp="20suj5nf6kyat">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-42" data-mp="1vz9tqjrnlcn8">
        <h2 className="font-serif-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-43" data-mp="1i00epnf6ooku">
          Tu consultorio organizado. Tu práctica profesional. Tu sistema listo para hoy.
        </h2>
        <p className="mt-4 text-lg font-medium text-sage sm:text-xl" data-id="element-44" data-mp="3nso4icxbjv8p">
          Sistema Nutri-Pro Completo™
        </p>

        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-45" data-mp="3slha130m37lu">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-46" data-mp="3dwtir8xstk1p">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage/20 text-sage" data-id="element-47" data-mp="3itjvpneb3ziw">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="afus2fzuqxe9" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-49" data-mp="fcl48s8jd8ue">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col items-center" data-id="element-50" data-mp="fu4uiyv3x4s">
          <span className="text-lg font-medium text-white/40 line-through sm:text-xl" data-id="element-51" data-mp="5exb26qkw9ec">$350 USD</span>
          <span className="font-serif-display text-[52px] font-bold leading-none text-sage sm:text-7xl" data-id="element-52" data-mp="2l6318blb05az">
            $17 USD
          </span>
        </div>

        <motion.a href="#comprar" animate={{
        y: [0, -2, 0]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 14px 30px -10px rgba(184, 255, 76, 0.68)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.4,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center gap-2 rounded-[10px] bg-[#B8FF4C] px-6 py-4 text-base font-extrabold text-[#24411D] shadow-lg shadow-[#B8FF4C]/30 sm:text-lg" data-id="element-53" data-mp="2q3l0tbdfl86b">
          Obtener el acceso AHORA
        </motion.a>
        <p className="mt-3 text-xs text-white/60" data-id="element-54" data-mp="3yt9f2vbbbgk">
          Acceso inmediato · Pago único · Conversión automática a tu moneda local · Garantía de 7 días
        </p>
      </motion.div>
    </section>;
}